import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  setMenuTopIndex,
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex
} from "../../../redux/actions/menuActions";
import CommercialList from "../../../containers/admin/CommercialList";
import MenuAdmin from "../Menu";
import Status from "components/status/Status.js";
import { Modal, Divider, Tooltip, Icon, DatePicker, Input } from "antd";
import { getReferentielsList, init } from "../../../redux/actions/referentielsActions";
import { setSort } from "../../../redux/actions/referentielsActions";

import { currentClientSelector } from "../../../redux/selectors/auth";
import { COMMERCIAL_DELETE, COMMERCIAL_CREATE, COMMERCIAL_UPDATE } from "../../../redux/types";

const { confirm } = Modal;
const { RangePicker } = DatePicker;
class CommercialPeriods extends Component {
  state = {
    isModalVisible: false,
    isUpdate: false,
    isCreate: false,
    label: null,
    active: null,
    start_date: null,
    end_date: null,
    id: null
  };
  componentDidMount() {
    this.props.setMenuTopIndex("imports");
    this.props.setMenuLeftContent(MenuAdmin);
    this.props.setMenuLeftIndex("commercial");
  }
  getColumns = () => {
    const columnsStatus = [
      {
        title: "Nom",
        dataIndex: "label",
        key: "label",
        sortable: true,
        render: (text, record, index) => {
          return <div>{record.label}</div>;
        }
      },
      {
        title: "Statut",
        dataIndex: "active",
        key: "active",
        sortable: true,
        render: (text, record, index) => {
          const isActive = record.active;
          const statusId = isActive ? 2 : 3;

          return <Status statusId={statusId} />;
        }
      },
      {
        title: "Période Commerciale",
        dataIndex: "period",
        key: "period",
        render: (text, record) => {
          return (
            <div>
              {moment(record.start_date).format("DD/MM/YYYY")} - {moment(record.end_date).format("DD/MM/YYYY")}
            </div>
          );
        }
      },
      {
        title: "Date de création",
        dataIndex: "created_at",
        key: "created_at",
        sortable: true,
        render: (text, record) => {
          return <div>{moment(record.created_at).format("DD/MM/YYYY")}</div>;
        }
      },
      {
        title: "Date de dernière modification",
        dataIndex: "updated_at",
        key: "updated_at",
        sortable: true,
        render: (text, record) => {
          return <div>{moment(record.updated_at).format("DD/MM/YYYY")}</div>;
        }
      },
      {
        title: "Actions",
        dataIndex: "actions",
        key: "actions",
        sortable: false,
        render: (text, record, index) => {
          return (
            <Fragment>
              <Fragment>
                <a
                  onClick={() => {
                    this.openModal("update", record);
                  }}
                >
                  <Tooltip placement="top" title={"Modifier"}>
                    <Icon type="edit" style={{ fontSize: 14, color: "#000000" }} />
                  </Tooltip>
                </a>
                <Divider type="vertical" />
              </Fragment>

              <Fragment>
                <a
                  onClick={() => {
                    confirm({
                      title: "Confirmation",
                      content: `Voulez-vous vraiment supprimer la période commerciale ${
                        record.label ? record.label : '"sans nom"'
                      } ?`,
                      onOk: () => {
                        this.setState({ isModalVisible: false });
                        this.props.deletePeriod(record.id);
                      },
                      onCancel() {}
                    });
                  }}
                >
                  <Tooltip placement="top" title={"Supprimer"}>
                    <Icon type="delete" style={{ fontSize: 14, color: "#000000" }} />
                  </Tooltip>
                </a>
              </Fragment>
            </Fragment>
          );
        }
      }
    ];
    return columnsStatus;
  };
  openModal = (type = "create", period) => {
    if (type === "update") {
      this.setState({
        isUpdate: true,
        isCreate: false,
        isModalVisible: true,
        id: period._id,
        label: period.label,
        active: period.active,
        start_date: period.start_date,
        end_date: period.end_date
      });
    } else {
      this.setState({
        isModalVisible: true,
        isUpdate: false,
        isCreate: true,
        active: true,
        start_date: null,
        end_date: null,
        label: ""
      });
    }
  };
  handleChange = event => {
    const target = event.target;
    const name = target.name;

    const value = target.type === "checkbox" ? target.checked : target.value;

    this.setState({ [name]: value });
  };
  onSubmit = () => {
    const { isCreate, isUpdate, id, active, start_date, end_date, label } = this.state;
    if (label !== null && active !== null && start_date !== null && end_date !== null) {
      const period = { label, active, start_date, end_date, id };
      if (isCreate) {
        this.props.createPeriod(period);
      } else if (isUpdate) {
        this.props.updatePeriod(period);
      } else {
        alert("Erreur dans la création");
      }
      this.setState({ isModalVisible: false });
    } else {
      alert("Veuillez renseigner tous les champs");
    }
  };
  render() {
    const { start_date, end_date } = this.state;
    return (
      <Fragment>
        <Modal
          visible={this.state.isModalVisible}
          onOk={() => {
            this.onSubmit();
          }}
          onCancel={() => this.setState({ isModalVisible: false })}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              height: 150
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
              <label htmlFor="label" style={{ marginBottom: 10 }}>
                Nom de la période commerciale
              </label>
              <Input
                id="label"
                name="label"
                type="text"
                value={this.state.label}
                onChange={this.handleChange}
                // style={{
                //   height: "35px",
                //   width: "100%",
                //   marginTop: 20
                // }}
              />
            </div>

            <div>
              <label htmlFor="active">Active</label>
              <input
                style={{ width: "30px" }}
                type="checkbox"
                id="active"
                name="active"
                checked={this.state.active}
                value={this.state.active}
                onChange={this.handleChange}
              ></input>
            </div>
            <RangePicker
              onChange={dates => {
                let start_date = dates[0];
                let end_date = dates[1];
                this.setState({ start_date, end_date });
              }}
              defaultValue={[
                start_date !== null ? moment(this.state.start_date) : null,
                end_date !== null ? moment(this.state.end_date) : null
              ]}
              size={"large"}
              format={"DD - MM - YYYY"}
            ></RangePicker>
          </div>
        </Modal>

        <CommercialList
          {...this.props}
          openModalForCreation={() => this.openModal("create")}
          columns={this.getColumns()}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    commercialList: state.commercial.commercialList,
    page: state.commercial.page,
    pages: state.commercial.pages,
    pageSize: state.commercial.pageSize,
    nbItems: state.commercial.commercialList.length,
    currentClientLabel: currentClientSelector(state).label,
    currentClientId: currentClientSelector(state).id
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    init: () => dispatch(init("commercial")),
    getNext: page => {
      const nextPage = page;
      dispatch(getReferentielsList({ page: nextPage }, "commercial"));
    },
    setSort: (column, sortOrder) => dispatch(setSort("commercial", column, sortOrder)),
    deletePeriod: id => dispatch({ type: COMMERCIAL_DELETE, id }),
    updatePeriod: period => dispatch({ type: COMMERCIAL_UPDATE, period }),
    createPeriod: period => dispatch({ type: COMMERCIAL_CREATE, period })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CommercialPeriods);



// WEBPACK FOOTER //
// src/pages/imports/imports/CommercialPeriods.js